import React, { useContext } from "react";
import { LanguageContext } from "../utils/context/languageContext";
import { LanguageKeys } from "../utils/languageKeys";
import { useConfig } from "../utils/context/configContext";

interface HeaderProps {
	title?: string;
	subtitle?: string;
	noTitle?: boolean;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, noTitle }) => {
	const { translate } = useContext(LanguageContext) || {};
	const config = useConfig();
	return (
		<div className="common-ui-main w-full">
			{config?.logo && (
				<div className="flex justify-start w-full ">
					<img
						src={config.logo}
						alt="logo"
						style={{
							height: config?.style?.logo?.logoHeight,
							width: config?.style?.logo?.logoWidth,
						}}
					/>
				</div>
			)}
			{!noTitle && (
				<h1
					style={{
						fontFamily: config?.style?.heading?.headingFontFamily || "SeriouslyNostalgic Fn",
						fontSize: config?.style?.heading?.headingFontSize ? config?.style?.heading?.headingFontSize : "32px",
						color: config?.style?.heading?.headingColor || "#000",
						fontWeight: config?.style?.heading?.headingFontWeight || "normal",
					}}
					className="text-center"
				>
					{title ? title : translate?.(LanguageKeys.welcome)}
				</h1>
			)}
			{subtitle && (
				<p
					style={{
						fontFamily: config?.style?.subheading?.subheadingFontFamily || "'Inter', sans-serif",
						fontSize: config?.style?.subheading?.subheadingFontSize || "14px",
						color: config?.style?.subheading?.subheadingColor || "#4b5563",
						fontWeight: config?.style?.subheading?.subheadingFontWeight || "normal",
					}}
				>
					{subtitle}
				</p>
			)}
		</div>
	);
};

export default Header;
